// FastAPI/Pydantic 422 → per-field i18n keys. The raw backend text
// ("String should have at most 3 characters") is never shown to users.
const KEY_BY_TYPE = {
  missing: "required",
  string_too_short: "required",
  string_too_long: "tooLong",
  value_error: "invalid",
  string_pattern_mismatch: "invalid",
  greater_than_equal: "invalid",
  less_than_equal: "invalid",
};

function keyFor(field, err) {
  const type = String(err?.type || "");
  if (field === "email") return { key: "email" };
  if (field === "password") return { key: "passwordShort", params: { min: err?.ctx?.min_length || 6 } };
  if (field === "country") return { key: "country" };
  if (type === "string_too_long") return { key: "tooLong", params: { max: err?.ctx?.max_length } };
  return { key: KEY_BY_TYPE[type] || KEY_BY_TYPE[type.split("_")[0]] || "invalid" };
}

/** @returns {Object<string, {key: string, params?: object}>} keyed by form field */
export function mapValidationErrors(detail) {
  const out = {};
  if (!Array.isArray(detail)) return out;
  for (const err of detail) {
    const loc = Array.isArray(err?.loc) ? err.loc : [];
    const field = String(loc[loc.length - 1] || "");
    if (!field || field === "body" || out[field]) continue;
    out[field] = keyFor(field, err);
  }
  return out;
}
